import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/bird.svg'
import _imports_1 from '../assets/img/staff2_150.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-f2d9e88c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  id: "logo",
  width: "200px",
  height: "55px"
}, [
  /*#__PURE__*/_createElementVNode("text", {
    x: "0",
    y: "40",
    class: "logo-txt logo-animated"
  }, "COUPE DESIGN")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "menu-column menu-translate" }
const _hoisted_5 = {
  viewBox: "0 0 850 100",
  class: "catchphrase",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_6 = {
  x: "50%",
  y: "50%",
  "text-anchor": "middle",
  "dominant-baseline": "middle",
  "font-size": "72",
  fill: "none",
  stroke: "black",
  "stroke-width": "2",
  "stroke-dasharray": "1000",
  "stroke-dashoffset": "1000"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("animate", {
  attributeName: "stroke-dashoffset",
  from: "1000",
  to: "0",
  dur: "2s",
  begin: "0s",
  fill: "freeze"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("set", {
  attributeName: "fill",
  to: "black",
  begin: "2s"
}, null, -1))
const _hoisted_9 = { class: "item-info" }
const _hoisted_10 = {
  key: 0,
  class: "item-info-right"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Bird",
  class: "bird-img"
}, null, -1))
const _hoisted_12 = { class: "speech-bubble" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "item-other bird"
}
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" alt=\"Bird\" class=\"bird-img\" data-v-f2d9e88c><div class=\"speech-bubble\" data-v-f2d9e88c><p data-v-f2d9e88c>📅 営業日のお知らせ</p><div class=\"calendar-container\" data-v-f2d9e88c><div class=\"calendar\" data-v-f2d9e88c><caption data-v-f2d9e88c>2026/4</caption><table data-v-f2d9e88c><thead data-v-f2d9e88c><tr data-v-f2d9e88c><th class=\"sun\" data-v-f2d9e88c>日</th><th data-v-f2d9e88c>月</th><th data-v-f2d9e88c>火</th><th data-v-f2d9e88c>水</th><th data-v-f2d9e88c>木</th><th data-v-f2d9e88c>金</th><th class=\"sat\" data-v-f2d9e88c>土</th></tr></thead><tbody data-v-f2d9e88c><tr data-v-f2d9e88c><td data-v-f2d9e88c></td><td data-v-f2d9e88c></td><td data-v-f2d9e88c></td><td data-v-f2d9e88c>1</td><td data-v-f2d9e88c>2</td><td data-v-f2d9e88c>3</td><td class=\"sat closed\" data-v-f2d9e88c>4</td></tr><tr data-v-f2d9e88c><td class=\"sun closed holiday\" data-v-f2d9e88c>5</td><td data-v-f2d9e88c>6</td><td data-v-f2d9e88c>7</td><td data-v-f2d9e88c>8</td><td data-v-f2d9e88c>9</td><td data-v-f2d9e88c>10</td><td class=\"sat closed\" data-v-f2d9e88c>11</td></tr><tr data-v-f2d9e88c><td class=\"sun closed holiday\" data-v-f2d9e88c>12</td><td data-v-f2d9e88c>13</td><td data-v-f2d9e88c>14</td><td data-v-f2d9e88c>15</td><td data-v-f2d9e88c>16</td><td data-v-f2d9e88c>17</td><td class=\"sat closed\" data-v-f2d9e88c>18</td></tr><tr data-v-f2d9e88c><td class=\"sun closed holiday\" data-v-f2d9e88c>19</td><td data-v-f2d9e88c>20</td><td data-v-f2d9e88c>21</td><td data-v-f2d9e88c>22</td><td data-v-f2d9e88c>23</td><td data-v-f2d9e88c>24</td><td class=\"sat closed\" data-v-f2d9e88c>25</td></tr><tr data-v-f2d9e88c><td class=\"sun closed holiday\" data-v-f2d9e88c>26</td><td class=\"closed\" data-v-f2d9e88c>27</td><td class=\"closed\" data-v-f2d9e88c>28</td><td class=\"closed holiday\" data-v-f2d9e88c>29</td><td data-v-f2d9e88c>30</td><td data-v-f2d9e88c></td><td data-v-f2d9e88c></td></tr></tbody></table></div><div class=\"calendar\" data-v-f2d9e88c><caption data-v-f2d9e88c>2026/5</caption><table data-v-f2d9e88c><thead data-v-f2d9e88c><tr data-v-f2d9e88c><th class=\"sun\" data-v-f2d9e88c>日</th><th data-v-f2d9e88c>月</th><th data-v-f2d9e88c>火</th><th data-v-f2d9e88c>水</th><th data-v-f2d9e88c>木</th><th data-v-f2d9e88c>金</th><th class=\"sat\" data-v-f2d9e88c>土</th></tr></thead><tbody data-v-f2d9e88c><tr data-v-f2d9e88c><td data-v-f2d9e88c></td><td data-v-f2d9e88c></td><td data-v-f2d9e88c></td><td data-v-f2d9e88c></td><td data-v-f2d9e88c></td><td data-v-f2d9e88c>1</td><td class=\"sat closed\" data-v-f2d9e88c>2</td></tr><tr data-v-f2d9e88c><td class=\"sun closed\" data-v-f2d9e88c>3</td><td class=\"closed holiday\" data-v-f2d9e88c>4</td><td class=\"closed holiday\" data-v-f2d9e88c>5</td><td class=\"closed holiday\" data-v-f2d9e88c>6</td><td data-v-f2d9e88c>7</td><td data-v-f2d9e88c>8</td><td class=\"sat\" data-v-f2d9e88c>9</td></tr><tr data-v-f2d9e88c><td class=\"sun closed\" data-v-f2d9e88c>10</td><td data-v-f2d9e88c>11</td><td data-v-f2d9e88c>12</td><td data-v-f2d9e88c>13</td><td data-v-f2d9e88c>14</td><td data-v-f2d9e88c>15</td><td class=\"sat closed\" data-v-f2d9e88c>16</td></tr><tr data-v-f2d9e88c><td class=\"sun closed\" data-v-f2d9e88c>17</td><td data-v-f2d9e88c>18</td><td data-v-f2d9e88c>19</td><td data-v-f2d9e88c>20</td><td data-v-f2d9e88c>21</td><td data-v-f2d9e88c>22</td><td class=\"sat closed\" data-v-f2d9e88c>23</td></tr><tr data-v-f2d9e88c><td class=\"sun closed\" data-v-f2d9e88c>24</td><td data-v-f2d9e88c>25</td><td data-v-f2d9e88c>26</td><td data-v-f2d9e88c>27</td><td data-v-f2d9e88c>28</td><td data-v-f2d9e88c>29</td><td class=\"sat closed\" data-v-f2d9e88c>30</td></tr><tr data-v-f2d9e88c><td class=\"sun closed\" data-v-f2d9e88c>31</td><td data-v-f2d9e88c></td><td data-v-f2d9e88c></td><td data-v-f2d9e88c></td><td data-v-f2d9e88c></td><td data-v-f2d9e88c></td><td data-v-f2d9e88c></td></tr></tbody></table></div></div></div>", 2)
const _hoisted_18 = [
  _hoisted_16
]
const _hoisted_19 = {
  key: 1,
  class: "item-other bird"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Bird",
  class: "bird-img"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "speech-bubble" }, [
  /*#__PURE__*/_createElementVNode("p", null, "📢 お知らせ"),
  /*#__PURE__*/_createElementVNode("p", null, "間違い電話が多くなっております。番号をご確認ください。")
], -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "item-staff-only" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "img-staff" }
const _hoisted_27 = { class: "item-updated" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 0,
  class: "footer-content"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "© 2026 株式会社クープデザイン All rights reserved.", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 1,
  class: "footer-content"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "© 2026 Coupe Design Co., Ltd. All rights reserved.", -1))
const _hoisted_35 = [
  _hoisted_34
]

import AboutUs from './AboutUs.vue';
import NoticeRegardingTransactions from './NoticeRegardingTransactions.vue';
import CompanyProfile from './CompanyProfile.vue';
import SupportExamples from './SupportExamples.vue';
import { ref, onMounted, watch, computed } from 'vue';

type Schedule = {
  start: string
  end: string
  message1: string
  message2: string
  message3: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutContainer',
  setup(__props) {

const translate = ref(true);
const code = ref('');

const holidays = [
  '2026-01-01',
  '2026-01-12',
  '2026-02-11',
  '2026-02-23',
  '2026-03-20',
  '2026-04-29',
  '2026-05-03',
  '2026-05-04',
  '2026-05-05',
  '2026-05-06',
  '2026-07-20',
  '2026-08-11',
  '2026-09-21',
  '2026-09-22',
  '2026-09-23',
  '2026-10-12',
  '2026-11-03',
  '2026-11-23'
]

 const today = new Date()

const todayStr = today.toISOString().slice(0, 10)

const isHoliday = holidays.includes(todayStr)

const week = ['日', '月', '火', '水', '木', '金', '土'][today.getDay()]

const todayText = computed(() => {
  const y = today.getFullYear()
  const m = today.getMonth() + 1
  const d = today.getDate()

  let suffix = ''
  if (isHoliday) suffix = '・祝'

  return `${y}.${m}.${d}（${week}${suffix}）`
})

const schedules: Schedule[] = [
  {
    start: '2026-05-01',
    end: '2026-05-01',
    message1: '本日は通常営業です。',
    message2: 'なお、外出やリモート作業のため担当者が不在の場合がございます。',
    message3: ''
  },
  {
    start: '2026-05-02',
    end: '2026-05-06',
    message1: '本日は休業日です。',
    message2: '',
    message3: ''
  },
  {
    start: '2026-05-07',
    end: '2026-05-08',
    message1: '本日は通常営業です。',
    message2: 'なお、外出やリモート作業のため担当者が不在の場合がございます。',
    message3: ''
  },
  {
    start: '2026-05-09',
    end: '2026-05-10',
    message1: '本日は休業日です。',
    message2: '',
    message3: ''
  },
  {
    start: '2026-05-11',
    end: '2026-05-15',
    message1: '本日は通常営業です。',
    message2: 'なお、外出やリモート作業のため担当者が不在の場合がございます。',
    message3: ''
  },
  {
    start: '2026-05-16',
    end: '2026-05-17',
    message1: '本日は休業日です。',
    message2: '',
    message3: ''
  },
  {
    start: '2026-05-18',
    end: '2026-05-22',
    message1: '本日は通常営業です。',
    message2: 'なお、外出やリモート作業のため担当者が不在の場合がございます。',
    message3: ''
  },
  {
    start: '2026-05-23',
    end: '2026-05-24',
    message1: '本日は休業日です。',
    message2: '',
    message3: ''
  },
  {
    start: '2026-05-25',
    end: '2026-05-29',
    message1: '本日は通常営業です。',
    message2: 'なお、外出やリモート作業のため担当者が不在の場合がございます。',
    message3: ''
  },
  {
    start: '2026-05-30',
    end: '2026-05-31',
    message1: '本日は休業日です。',
    message2: '',
    message3: ''
  },
  {
    start: '2026-06-01',
    end: '2026-06-05',
    message1: '本日は通常営業です。',
    message2: 'なお、外出やリモート作業のため担当者が不在の場合がございます。',
    message3: ''
  }
]

const todaySchedules = computed(() => {
  today.setHours(0, 0, 0, 0)

  return schedules.filter(item => {
    const start = new Date(item.start)
    start.setHours(0, 0, 0, 0)

    const end = new Date(item.end)
    end.setHours(23, 59, 59, 999)

    return today >= start && today <= end
  })
})

function top() {
  // 
  location.href = '/';
}
function gotoStaffPage() {
  // 
  return;
}

onMounted(() => {
  const savedLanguage = localStorage.getItem('translate');
  if (savedLanguage !== null) {
    translate.value = JSON.parse(savedLanguage);
  }
});

watch(translate, (newValue) => {
  localStorage.setItem('translate', JSON.stringify(newValue));
});


return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      mode: "horizontal",
      ellipsis: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (top())),
          class: "menu-column menu-logo"
        }, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_switch, {
            modelValue: translate.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((translate).value = $event)),
            class: "sw-translate",
            style: {"--el-switch-on-color":"#cbcba0","--el-switch-off-color":"#85ab96"},
            "active-text": "日本語",
            "inactive-text": "EN"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      (_openBlock(), _createElementBlock("svg", _hoisted_5, [
        _createElementVNode("text", _hoisted_6, [
          _createTextVNode(_toDisplayString(translate.value ? '進化する、ものづくり。' : 'Evolving, our products.') + " ", 1),
          _hoisted_7,
          _hoisted_8
        ])
      ]))
    ]),
    _createVNode(_component_el_carousel, {
      class: "is-mobile",
      height: "500px",
      arrow: "always",
      autoplay: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "item-about-us" }, {
              default: _withCtx(() => [
                _createVNode(AboutUs, { translate: translate.value }, null, 8, ["translate"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "item-transactions" }, {
              default: _withCtx(() => [
                _createVNode(NoticeRegardingTransactions, { translate: translate.value }, null, 8, ["translate"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "item-company-profile" }, {
              default: _withCtx(() => [
                _createVNode(CompanyProfile, { translate: translate.value }, null, 8, ["translate"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (translate.value)
          ? (_openBlock(), _createBlock(_component_el_carousel_item, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_main, { class: "item-support-examples" }, {
                  default: _withCtx(() => [
                    _createVNode(SupportExamples, { translate: translate.value }, null, 8, ["translate"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_el_carousel, {
      class: "is-pc",
      height: "500px",
      type: "card",
      autoplay: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "item-about-us" }, {
              default: _withCtx(() => [
                _createVNode(AboutUs, { translate: translate.value }, null, 8, ["translate"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "item-company-profile" }, {
              default: _withCtx(() => [
                _createVNode(CompanyProfile, { translate: translate.value }, null, 8, ["translate"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "item-transactions" }, {
              default: _withCtx(() => [
                _createVNode(NoticeRegardingTransactions, { translate: translate.value }, null, 8, ["translate"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (translate.value)
          ? (_openBlock(), _createBlock(_component_el_carousel_item, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_main, { class: "item-support-examples" }, {
                  default: _withCtx(() => [
                    _createVNode(SupportExamples, { translate: translate.value }, null, 8, ["translate"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_9, [
      (translate.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(todaySchedules.value, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "item-other bird"
              }, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", null, "📅 " + _toDisplayString(todayText.value), 1),
                  _createElementVNode("p", null, _toDisplayString(item.message1), 1),
                  (item.message2)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(item.message2), 1))
                    : _createCommentVNode("", true),
                  (item.message3)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(item.message3), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128)),
            true
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18))
              : _createCommentVNode("", true),
            true
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              (translate.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_24, "関係者入口"))
                : (_openBlock(), _createElementBlock("p", _hoisted_25, "Staff Only")),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("img", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (gotoStaffPage())),
                  src: _imports_1
                }),
                _createVNode(_component_el_input, {
                  modelValue: code.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((code).value = $event)),
                  style: {"width":"100px"},
                  placeholder: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_27, [
      (translate.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_28, "更新日: 2026.4.23"))
        : (_openBlock(), _createElementBlock("p", _hoisted_29, "Updated: April 23, 2026"))
    ]),
    _createElementVNode("footer", null, [
      (translate.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
        : (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
    ])
  ]))
}
}

})